import React from "react";
import Newsletter from "./NewsLetter"; // ✅ Import the Newsletter component
import FooterCategories from "./FooterCategories";

const Footer = () => {
    return (
        <div className="footer">
            <div className="container">
                <div className="row">
                    {/* Newsletter Section */}
                    <div className="col-lg-4 col-md-6">
                    <Newsletter />
                    
                    </div>

                    {/* Quick Links Section */}
                    <div className="col-lg-4 col-md-6">
                    <FooterCategories />
                    </div>

                    {/* Get in Touch Section
                    <div className="col-lg-3 col-md-6">
                        <div className="footer-widget">
                            <h3 className="title">Get in Touch</h3>
                            <div className="contact-info">
                                <p><i className="fa fa-map-marker"></i> 123 News Street, NY, USA</p>
                                <p><i className="fa fa-envelope"></i> info@example.com</p>
                                <p><i className="fa fa-phone"></i> +123-456-7890</p>
                                <div className="social">
                                    {["twitter", "facebook-f", "linkedin-in", "instagram", "youtube"].map((icon, index) => (
                                        <a href="#" key={index}><i className={`fab fa-${icon}`}></i></a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* Useful Links Section */}
                    <div className="col-lg-4 col-md-6">
                        <div className="footer-widget">
                            <h3 className="title">Useful Links</h3>
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><a href="/signup">Signup</a></li>
                                <li><a href="/login">Login</a></li>
                                <li><a href="/contact">Contact</a></li>
                                <li><a href="/about-us">About Us</a></li>
                                <li><a href="/privacy-policy">Privacy Policy</a></li>
                            </ul>
                        </div>
                    </div>

                    
                    
                </div>
            </div>
        </div>
    );
};

export default Footer;
